<template>
  <div ref="attrTabRef" >


    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19"/>
      <h4 class="mb-0 ml-50">
        {{ $t('Device Sensor Settings')}}
      </h4>
    </div>


    <b-form class="mt-2">
      <b-row >
        <b-col cols="12">
          <!-- Row Loop -->
          <b-row
              v-for="(item, index) in deviceData.scaleSensorsSetting"
              :id="item.id"
              :key="index"
              ref="rowRef"
          >

            <!-- Item Key -->
            <b-col md="5">
              <b-form-group :label="$t('Key')">
                <b-form-input v-model="item.key" placeholder="ex. 20"/>
              </b-form-group>
            </b-col>


            <!-- Value -->
            <b-col md="5">
              <b-form-group :label="$t('value')">
                <b-form-input v-model="item.value" placeholder="ex. 80"/>
              </b-form-group>
            </b-col>


            <!-- Remove Button -->
            <b-col lg="2" md="2" class="mb-50">
              <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="mt-0 mt-md-2"
                  @click="removeItem(deviceData.scaleSensorsSetting, index)"
              >
                <feather-icon icon="XIcon" class="mr-25"/>
                <span>{{ $t('Delete')}}</span>
              </b-button>
            </b-col>

          </b-row>
        </b-col>

        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="newAttr">
            <feather-icon icon="PlusIcon" class="mr-25"/>
            <span>{{ $t('add sensor setting') }}</span>
          </b-button>
        </b-col>
        <b-col cols="12"><hr></b-col>
      </b-row>
    </b-form>

  </div>

</template>

<script>

import {
  BButton,
  BCard, BCol,
  BForm, BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { ref, onMounted, on, onUnmounted, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import useRepeater from '@/views/modules/useRepeater'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCard,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner
  },

  setup(props, {root}) {

    const { initTrHeight, repeatAgain, removeItem, attrTabRef, rowRef } = useRepeater(root)

    window.addEventListener('resize', initTrHeight)

    onMounted(() => {
      initTrHeight()
    })

    onUnmounted(() => {
      window.removeEventListener('resize', initTrHeight)
    })

    const deviceData = computed(() => root.$store.state.device.data)

    const newAttr = () => {
      const attrs = repeatAgain(deviceData.value.scaleSensorsSetting)
      root.$store.dispatch('device/updateScaleSensors', attrs).then(res => {})
    }


    return {
      deviceData,
      newAttr,
      removeItem,
      repeatAgain,
      attrTabRef,
      rowRef,
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
